export default __webpack_public_path__ + "static/media/miguel-lopes-1.db3ea5a2.jpg";